import React from 'react';
import Banner from './Banner';

const Skills = () => {
  return (
    <>
      <Banner title="Skills" />
      <div className="grid grid-cols-2 gap-2 xs:grid-cols-1 xs:gap-1 py-4">
        <div className="timeline-container m-2">
          <div className="timeline-card p-3 md:p-5 lg:p-6 my-2 md:my-4 text-secondary">
            <p className="text-sm md:text-lg lg:text-2xl font-bold text-primary">
              Technical
            </p>
            <p className="text-sm md:text-lg lg:text-lg py-1 text-secondary">
              Programming, Scripting languages and runtime environments.
            </p>
            <ul class="list-disc mx-4 xs:text-xs">
              <li>PHP</li>
              <li>Javascript</li>
              <li>TypeScript</li>
              <li>Node Js</li>
              <li>Golang</li>
              <li>HTML</li>
              <li>SCSS,CSS</li>
            </ul>
            <p className="text-sm md:text-lg lg:text-lg pt-5 text-secondary">
              Frameworks, Libraries and Packages.
            </p>
            <ul class="list-disc mx-4 xs:text-xs">
              <li>Laravel, Lumen, Symfony, CodeIgniter</li>
              <li>Express, NestJs</li>
              <li>React, Vue, RiotJs, Jquery</li>
              <li>Bootstrap, Tailwind CSS</li>
            </ul>
            <p className="text-sm md:text-lg lg:text-lg pt-5 text-secondary">
              Database and Utilities
            </p>
            <ul class="list-disc mx-4 xs:text-xs">
              <li>PostgreSQL, MySQL/MariaDB</li>
              <li>MongoDb</li>
              <li>GraphQL</li>
              <li>Redis</li>
            </ul>
            <p className="text-sm md:text-lg lg:text-lg pt-5 text-secondary">
              Other tools and technologies
            </p>
            <ul class="list-disc mx-4 xs:text-xs">
              <li>Test driven development (TDD)</li>
              <li>Agile/PWA development</li>
              <li>GIT</li>
              <li>CI/CD (Jenkins, Bitbucket pipelines)</li>
              <li>Amazon web services</li>
            </ul>
          </div>
        </div>
        <div className="timeline-container m-2">
          <div className="timeline-card p-3 md:p-5 lg:p-6 my-2 md:my-4 text-secondary">
            <p className="text-sm md:text-lg lg:text-2xl font-bold text-primary">
              Interpersonal/Professional
            </p>
            <p className="text-sm md:text-lg lg:text-lg py-1 text-secondary">
              Soft skills
            </p>
            <ul class="list-disc mx-4 xs:text-xs">
              <li>Teamwork</li>
              <li>Time management</li>
              <li>Creativity</li>
              <li>Effective Communication</li>
              <li>Adaptability</li>
            </ul>
            <p className="text-sm md:text-lg lg:text-lg pt-5 text-secondary">
              Languages
            </p>
            <ul class="list-disc mx-4 xs:text-xs">
              <li>English</li>
              <li>Sinhala</li>
            </ul>
            <p className="text-sm md:text-lg lg:text-lg pt-5 text-secondary">
              Interest in
            </p>
            <ul class="list-disc mx-4 xs:text-xs">
              <li>Coding</li>
              <li>Listening music</li>
              <li>Watching movies</li>
              <li>🐱 lover</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Skills;
